import { render, staticRenderFns } from "./SurveyIndexView.vue?vue&type=template&id=298b6b47&scoped=true"
import script from "./SurveyIndexView.vue?vue&type=script&lang=js"
export * from "./SurveyIndexView.vue?vue&type=script&lang=js"
import style0 from "./SurveyIndexView.vue?vue&type=style&index=0&id=298b6b47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b6b47",
  null
  
)

export default component.exports